interface LegacyNavigationTiming {
  readonly type: number;
  readonly TYPE_RELOAD: number;
}

interface RefreshNavigationContext {
  readonly baseUri: string;
  readonly history: Pick<History, 'replaceState' | 'state'>;
  readonly location: Pick<Location, 'hash' | 'pathname' | 'search'>;
  readonly performance: Pick<Performance, 'getEntriesByType'> & {
    readonly navigation?: LegacyNavigationTiming;
  };
}

export function redirectReloadToHome(context: RefreshNavigationContext): void {
  if (!isReload(context.performance)) {
    return;
  }

  const homePath = new URL(context.baseUri).pathname;
  const isAlreadyHome =
    context.location.pathname === homePath &&
    !context.location.search &&
    !context.location.hash;

  if (!isAlreadyHome) {
    context.history.replaceState(context.history.state, '', homePath);
  }
}

function isReload(performance: RefreshNavigationContext['performance']): boolean {
  const navigationEntry =
    performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;

  if (navigationEntry) {
    return navigationEntry.type === 'reload';
  }

  const legacyNavigation = performance.navigation;
  return !!legacyNavigation &&
    legacyNavigation.type === legacyNavigation.TYPE_RELOAD;
}
